import "./styles.css";
import { useNavigate } from "react-router-dom";
import TextInput from "../../Inputs/TextInput";
import { useLeadForm } from "../../../context/leadform";
import { trackLeadFormSubmit } from "../../../Leadform/tracking";

function FinalStep() {
  const { responses, setLoading } = useLeadForm();
  const navigate = useNavigate();

  const submitForm = (values: { [key: string]: any }) => {
    trackLeadFormSubmit(values);

    setLoading(true);
    return fetch("/wp-json/wordpress-leadform/v1/send", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...values }), // Send data in the request body
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        const response = JSON.parse(data);
        navigate("/submission/" + response.uuid);
        console.log(data);
      })
      .catch((error) => {
        setLoading(false);
        // console.error('Error:', error)
      });
  };

  return (
    <div className="Step FinalStep">
      <h2>Great news — we’ve found cash buyers interested in your property</h2>
      <p>
        Before we show your comparison, please re-confirm the following details.
      </p>

      <TextInput
        inline={true}
        label="Email"
        validate="email"
        statekey={"confirm_email"}
      />
      <TextInput
        inline={true}
        label="Phone Number"
        validate="phone"
        statekey={"confirm_phone_number"}
      />

      <p>
        <i>Buyers will only contact if you choose to request an offer.</i>
      </p>

      <div className="Buttons">
        <button className="Primary" onClick={() => submitForm(responses)}>
          Submit
        </button>
      </div>
    </div>
  );
}

export default FinalStep;
